import EditNote from '@mui/icons-material/EditNote';
import { MenuItem } from '@src/common/components/Menu';
import {
  actionIconStyle,
  menuItemStyle,
} from '@src/orders/components/permitList/PermitActions/PermitActionsStyles';
import { Navigation } from '@src/routing/Navigation';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface Props extends ComponentPropsWithoutRef<typeof MenuItem> {
  orderId: string;
  permitId: string;
}
export const CompleteForm = forwardRef<HTMLLIElement, Props>(
  ({ orderId, permitId, ...menuItemProps }, ref) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleProcessClick = () => {
      navigate(Navigation.orders.completePermitForm.url(orderId, permitId));
    };
    return (
      <>
        <MenuItem
          {...menuItemProps}
          ref={ref}
          className={menuItemStyle}
          onClick={handleProcessClick}
        >
          <EditNote style={actionIconStyle} />
          {t('permitApplication.completeForm')}
        </MenuItem>
      </>
    );
  },
);
